"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _IdInfo = _interopRequireDefault(require("@rsuite/icon-font/lib/people/IdInfo"));

// Generated by script, don't edit it please.
var IdInfo = (0, _createSvgIcon["default"])({
  as: _IdInfo["default"],
  ariaLabel: 'id info',
  category: 'people',
  displayName: 'IdInfo'
});
var _default = IdInfo;
exports["default"] = _default;
module.exports = exports.default;